// frontend/src/components/CashierHeader.js
import { authService } from '../services/authService.js';

// Estas importaciones apuntarán a los modales que crearemos o que ya tienes
import { showRaceResults, showTicketList, showCashReconciliation } from './cashier/ReportModals.js';
import { openConfigModal } from './cashier/ConfigModal.js';
import { onShowMirroring } from './cashier/ScreenMirroring.js';
import { openPayoutModal } from './cashier/PayoutModal.js';

export function CashierHeader() {
    const header = document.createElement('header');
    header.className = 'taquilla-header flex justify-between items-center w-full'; 
    
    header.innerHTML = `
        <div class="header-actions-group flex gap-2">
            <button id="showRaceResultsBtn" class="header-action-button">Resultados</button>
            <button id="showTicketListBtn" class="header-action-button">Tickets</button>
            <button id="showCashReconciliationBtn" class="header-action-button">Cuadre</button>
            <button id="showConfigurationsBtn" class="header-action-button">Configuración</button>
            <button id="showMirroringBtn" class="header-action-button">Pantallas</button>
            
            <button id="globalPayoutBtn" class="header-action-button" style="background-color: #9333ea !important; color: white !important;">Pagar Premio</button>
            <button id="globalVoidBtn" class="header-action-button" style="background-color: #ea580c !important; color: white !important;">Anular Ticket</button>
        </div>
        
        <div class="header-actions-group">
            <button id="logoutButton" class="header-action-button" style="background-color: #7f1d1d !important; border-color: #D4AF37 !important;">Cerrar Sesión</button>
        </div>
    `;

    // Asignamos los eventos importados a cada botón
    header.querySelector('#showRaceResultsBtn').addEventListener('click', (e) => { e.preventDefault(); showRaceResults(); });
    header.querySelector('#showTicketListBtn').addEventListener('click', (e) => { e.preventDefault(); showTicketList(); });
    header.querySelector('#showCashReconciliationBtn').addEventListener('click', (e) => { e.preventDefault(); showCashReconciliation(); });
    header.querySelector('#showConfigurationsBtn').addEventListener('click', (e) => { e.preventDefault(); openConfigModal(); });
    header.querySelector('#showMirroringBtn').addEventListener('click', (e) => { e.preventDefault(); onShowMirroring(); });
    
    header.querySelector('#globalPayoutBtn').addEventListener('click', (e) => { e.preventDefault(); openPayoutModal('Pagar Premio'); });
    header.querySelector('#globalVoidBtn').addEventListener('click', (e) => { e.preventDefault(); openPayoutModal('Anular Ticket'); });
    
    header.querySelector('#logoutButton').addEventListener('click', (e) => { 
        e.preventDefault(); 
        authService.logout(); 
        window.location.href = '/login';
    });

    return header;
}